/* V10a: one cart + pending-selection calculation for product and cart widgets. */
(function (root) {
  'use strict';
  const integer = value => Math.max(0, Math.round(Number(value) || 0));
  const rate = quantity => quantity >= 10 ? 15 : quantity >= 6 ? 10 : quantity >= 3 ? 5 : 0;
  function calculate(data, pending) {
    const cart = data.cart || {}, items = cart.items || [];
    const eligible = new Set((data.eligibleProductIds || []).map(String));
    const skins = items.filter(item => eligible.has(String(item.product_id)));
    const cartSkinQuantity = skins.reduce((n, item) => n + integer(item.quantity), 0);
    const pendingQuantity = pending.reduce((n, item) => n + integer(item.quantity), 0);
    const skinQuantity = cartSkinQuantity + pending.filter(item => item.eligible).reduce((n, item) => n + integer(item.quantity), 0);
    const pendingRaw = pending.reduce((n, item) => n + integer(item.price) * integer(item.quantity), 0);
    const cartRaw = integer(cart.original_total_price);
    const raw = cartRaw + pendingRaw, tier = rate(skinQuantity);
    const lineRaw = item => integer(item.original_line_price == null ? item.line_price : item.original_line_price);
    const tierSaving = skins.reduce((n, item) => n + Math.round(lineRaw(item) * tier / 100), 0)
      + pending.filter(item => item.eligible).reduce((n, item) => n + Math.round(integer(item.price) * integer(item.quantity) * tier / 100), 0);
    // The configured volume offers do not combine with other product/order offers.
    // Preserve any better existing Shopify discount; never discount other products.
    const existingSaving = Math.max(0, cartRaw - integer(cart.total_price));
    const volumeWins = tierSaving >= existingSaving;
    const saving = pending.length ? Math.max(existingSaving, tierSaving) : existingSaving;
    const appliedRate = pending.length ? (volumeWins ? tier : 0) : (skins.some(item => (item.line_level_discount_allocations || item.discount_allocations || []).some(a => /E-reader Skins:/i.test((a.discount_application || {}).title || ''))) ? tier : 0);
    const pendingSaving = pending.filter(item => item.eligible).reduce((n, item) => n + Math.round(integer(item.price) * integer(item.quantity) * appliedRate / 100), 0);
    return { pending, pendingQuantity, pendingRaw, pendingTotal: pendingRaw - pendingSaving,
      skinQuantity, cartSkinQuantity, cartRaw, raw, saving, appliedRate, tier,
      total: pending.length ? Math.max(0, raw - saving) : integer(cart.total_price),
      currency: cart.currency || 'AUD' };
  }
  if (typeof module === 'object' && module.exports) { module.exports = { calculate, rate }; return; }
  if (root.TLCFinance) return;
  const node = document.querySelector('[data-tlc-finance-state]');
  if (!node) return;
  let data;
  try { data = JSON.parse(node.textContent); } catch (error) { console.error('Cart pricing data unavailable', error); return; }
  const page = { product: data.product, eligible: data.pageEligible };
  const sources = new Map(), submitted = new Map(), listeners = new Set();
  let inflight = null, queued = false, notifyOtherTabs = false, channel = null;
  let lastError = false;
  const signature = item => JSON.stringify(item);
  const pending = () => Array.from(sources.entries()).flatMap(([source, lines]) => lines.filter(line => (submitted.get(source) || new Map()).get(String(line.id)) !== signature(line)));
  const snapshot = () => Object.assign(calculate(data, pending()), { stale: lastError });
  const emit = () => {
    const cartLink = document.getElementById('cart-icon-bubble');
    if (cartLink) cartLink.setAttribute('aria-label', 'Cart (' + integer(data.cart.item_count) + ' items)');
    listeners.forEach(fn => fn(snapshot()));
  };
  function setSelection(source, lines) {
    if (JSON.stringify(sources.get(source) || []) === JSON.stringify(lines)) return;
    sources.set(source, lines); emit();
  }
  function editSelection(source) { submitted.delete(source); }
  async function commit(source, ids) {
    const map = submitted.get(source) || new Map();
    (sources.get(source) || []).forEach(line => {
      if (!ids || ids.includes(String(line.id))) map.set(String(line.id), signature(line));
    });
    submitted.set(source, map);
    await refresh(true);
  }
  async function readCart() {
    const url = new URL((data.root || '/') + 'cart', location.origin);
    url.searchParams.set('section_id', 'tlc-finance-state');
    url.searchParams.set('_tlc', Date.now());
    const response = await fetch(url, { cache: 'no-store', headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error('Could not refresh cart');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const script = doc.querySelector('[data-tlc-finance-state]');
    if (!script) throw new Error('Cart pricing section unavailable');
    const next = JSON.parse(script.textContent);
    if (!next.cart || !Array.isArray(next.cart.items)) throw new Error('Invalid cart data');
    data = next;
  }
  function refresh(changed) {
    if (changed) { queued = true; notifyOtherTabs = true; }
    if (inflight) return inflight;
    inflight = (async () => {
      do {
        queued = false;
        try { await readCart(); lastError = false; }
        catch (error) { lastError = true; console.warn('Cart pricing refresh failed', error); }
      } while (queued);
      emit();
      if (notifyOtherTabs) {
        notifyOtherTabs = false;
        if (channel) channel.postMessage('changed');
        else { try { localStorage.setItem('tlc-cart-changed', String(Date.now())); } catch (_) {} }
      }
    })().finally(() => { inflight = null; });
    return inflight;
  }
  function subscribe(fn) { listeners.add(fn); fn(snapshot()); return () => listeners.delete(fn); }
  let externalRefresh = null;
  async function refreshExternal() {
    if (externalRefresh) return externalRefresh;
    externalRefresh = (async () => {
      await refresh();
      const cartItems = document.querySelector('cart-items');
      const sections = cartItems && cartItems.getSectionsToRender ? cartItems.getSectionsToRender() : [{id:'cart-icon-bubble',section:'cart-icon-bubble',selector:'.shopify-section'}];
      const url = new URL((data.root || '/') + 'cart', location.origin);
      url.searchParams.set('sections',sections.map(s => s.section).join(','));
      const response = await fetch(url,{cache:'no-store'});
      if (!response.ok) return;
      const rendered = await response.json();
      sections.forEach(section => {
        const target = document.getElementById(section.id);
        if (!target || !rendered[section.section]) return;
        const doc = new DOMParser().parseFromString(rendered[section.section],'text/html');
        const fresh = doc.querySelector(section.selector);
        if (fresh) (target.querySelector(section.selector) || target).innerHTML = fresh.innerHTML;
      });
      if (cartItems) {
        cartItems.classList.toggle('is-empty',!data.cart.item_count);
        cartItems.currentItemCount = data.cart.item_count;
        const footer = document.getElementById('main-cart-footer');
        if (footer) footer.classList.toggle('is-empty',!data.cart.item_count);
      }
    })().catch(error => console.warn('Cart display refresh failed',error)).finally(() => {externalRefresh = null});
    return externalRefresh;
  }
  root.TLCFinance = { calculate, snapshot, setSelection, editSelection, commit, refresh, subscribe,
    pageEligible: page.eligible, product: page.product };
  try { channel = new BroadcastChannel('tlc-cart'); channel.onmessage = refreshExternal; } catch (_) {}
  window.addEventListener('storage', event => { if (event.key === 'tlc-cart-changed') refreshExternal(); });
  window.addEventListener('pageshow', event => { if(event.persisted) refreshExternal(); else refresh(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshExternal(); });
  ['cart:updated', 'cart:update'].forEach(name => document.addEventListener(name, () => refresh()));
  document.addEventListener('shopify:section:load', () => refresh());
})(typeof window === 'undefined' ? globalThis : window);
